import { default as feedback6ygvq6yEkTMeta } from "/vercel/path0/pages/admin/feedback.vue?macro=true";
import { default as indexG7R2Mya2P4Meta } from "/vercel/path0/pages/admin/index.vue?macro=true";
import { default as ordersTEuu2F15mdMeta } from "/vercel/path0/pages/admin/orders.vue?macro=true";
import { default as paymentsqWvZO2qmb3Meta } from "/vercel/path0/pages/admin/payments.vue?macro=true";
import { default as tasksfh2Qr4o982Meta } from "/vercel/path0/pages/admin/tasks.vue?macro=true";
import { default as usersjvZRxTajERMeta } from "/vercel/path0/pages/admin/users.vue?macro=true";
import { default as ai_45poseWfCVbdfCgyMeta } from "/vercel/path0/pages/ai-pose.vue?macro=true";
import { default as ai_45videoCRnd3c2MPsMeta } from "/vercel/path0/pages/ai-video.vue?macro=true";
import { default as checkoutlZQLvi17ODMeta } from "/vercel/path0/pages/checkout.vue?macro=true";
import { default as contactJnsDpYVejzMeta } from "/vercel/path0/pages/contact.vue?macro=true";
import { default as content_45monitoring_45policyd3f6ehtswWMeta } from "/vercel/path0/pages/content-monitoring-policy.vue?macro=true";
import { default as creation_detail0bpyLZFDn6Meta } from "/vercel/path0/pages/creation_detail.vue?macro=true";
import { default as editor28b1wOPw0RMeta } from "/vercel/path0/pages/editor.vue?macro=true";
import { default as face_45swap_45photowVOTMvKAwaMeta } from "/vercel/path0/pages/face-swap-photo.vue?macro=true";
import { default as face_45swap_45videoGyoUkhjUB2Meta } from "/vercel/path0/pages/face-swap-video.vue?macro=true";
import { default as face_45swapgJYtqBo06tMeta } from "/vercel/path0/pages/face-swap.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as _91_91site_93_93f0F0e6ZtvBMeta } from "/vercel/path0/pages/login/[[site]].vue?macro=true";
import { default as accountzGIuhQIyqWMeta } from "/vercel/path0/pages/my/account.vue?macro=true";
import { default as creationsW7Czw5OYYPMeta } from "/vercel/path0/pages/my/creations.vue?macro=true";
import { default as creditskqpXEn0UasMeta } from "/vercel/path0/pages/my/credits.vue?macro=true";
import { default as facesxYqkQdfqX9Meta } from "/vercel/path0/pages/my/faces.vue?macro=true";
import { default as uploadscZSp4yZfr0Meta } from "/vercel/path0/pages/my/uploads.vue?macro=true";
import { default as my0dargHxM6iMeta } from "/vercel/path0/pages/my.vue?macro=true";
import { default as password_45changeqT7uDbh29HMeta } from "/vercel/path0/pages/password-change.vue?macro=true";
import { default as password_45reset6pLgh9teUjMeta } from "/vercel/path0/pages/password-reset.vue?macro=true";
import { default as payment_45failedisTKdFKLwvMeta } from "/vercel/path0/pages/payment-failed.vue?macro=true";
import { default as payment_45successAGfXBekK7fMeta } from "/vercel/path0/pages/payment-success.vue?macro=true";
import { default as policyNKohT57BqpMeta } from "/vercel/path0/pages/policy.vue?macro=true";
import { default as pricingIYNdvfoSO6Meta } from "/vercel/path0/pages/pricing.vue?macro=true";
import { default as redeemn604VeRd4vMeta } from "/vercel/path0/pages/redeem.vue?macro=true";
import { default as signupY93ILdpGpbMeta } from "/vercel/path0/pages/signup.vue?macro=true";
import { default as termsq5qlZHSSonMeta } from "/vercel/path0/pages/terms.vue?macro=true";
import { default as g2a_45instructionJWnLXVDs0aMeta } from "/vercel/path0/pages/tutorial/g2a-instruction.vue?macro=true";
export default [
  {
    name: feedback6ygvq6yEkTMeta?.name ?? "admin-feedback___en",
    path: feedback6ygvq6yEkTMeta?.path ?? "/admin/feedback",
    meta: feedback6ygvq6yEkTMeta || {},
    alias: feedback6ygvq6yEkTMeta?.alias || [],
    redirect: feedback6ygvq6yEkTMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedback6ygvq6yEkTMeta?.name ?? "admin-feedback___ja",
    path: feedback6ygvq6yEkTMeta?.path ?? "/ja/admin/feedback",
    meta: feedback6ygvq6yEkTMeta || {},
    alias: feedback6ygvq6yEkTMeta?.alias || [],
    redirect: feedback6ygvq6yEkTMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedback6ygvq6yEkTMeta?.name ?? "admin-feedback___de",
    path: feedback6ygvq6yEkTMeta?.path ?? "/de/admin/feedback",
    meta: feedback6ygvq6yEkTMeta || {},
    alias: feedback6ygvq6yEkTMeta?.alias || [],
    redirect: feedback6ygvq6yEkTMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedback6ygvq6yEkTMeta?.name ?? "admin-feedback___it",
    path: feedback6ygvq6yEkTMeta?.path ?? "/it/admin/feedback",
    meta: feedback6ygvq6yEkTMeta || {},
    alias: feedback6ygvq6yEkTMeta?.alias || [],
    redirect: feedback6ygvq6yEkTMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedback6ygvq6yEkTMeta?.name ?? "admin-feedback___fr",
    path: feedback6ygvq6yEkTMeta?.path ?? "/fr/admin/feedback",
    meta: feedback6ygvq6yEkTMeta || {},
    alias: feedback6ygvq6yEkTMeta?.alias || [],
    redirect: feedback6ygvq6yEkTMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedback6ygvq6yEkTMeta?.name ?? "admin-feedback___nl",
    path: feedback6ygvq6yEkTMeta?.path ?? "/nl/admin/feedback",
    meta: feedback6ygvq6yEkTMeta || {},
    alias: feedback6ygvq6yEkTMeta?.alias || [],
    redirect: feedback6ygvq6yEkTMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedback6ygvq6yEkTMeta?.name ?? "admin-feedback___pt",
    path: feedback6ygvq6yEkTMeta?.path ?? "/pt/admin/feedback",
    meta: feedback6ygvq6yEkTMeta || {},
    alias: feedback6ygvq6yEkTMeta?.alias || [],
    redirect: feedback6ygvq6yEkTMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/feedback.vue").then(m => m.default || m)
  },
  {
    name: indexG7R2Mya2P4Meta?.name ?? "admin___en",
    path: indexG7R2Mya2P4Meta?.path ?? "/admin",
    meta: indexG7R2Mya2P4Meta || {},
    alias: indexG7R2Mya2P4Meta?.alias || [],
    redirect: indexG7R2Mya2P4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexG7R2Mya2P4Meta?.name ?? "admin___ja",
    path: indexG7R2Mya2P4Meta?.path ?? "/ja/admin",
    meta: indexG7R2Mya2P4Meta || {},
    alias: indexG7R2Mya2P4Meta?.alias || [],
    redirect: indexG7R2Mya2P4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexG7R2Mya2P4Meta?.name ?? "admin___de",
    path: indexG7R2Mya2P4Meta?.path ?? "/de/admin",
    meta: indexG7R2Mya2P4Meta || {},
    alias: indexG7R2Mya2P4Meta?.alias || [],
    redirect: indexG7R2Mya2P4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexG7R2Mya2P4Meta?.name ?? "admin___it",
    path: indexG7R2Mya2P4Meta?.path ?? "/it/admin",
    meta: indexG7R2Mya2P4Meta || {},
    alias: indexG7R2Mya2P4Meta?.alias || [],
    redirect: indexG7R2Mya2P4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexG7R2Mya2P4Meta?.name ?? "admin___fr",
    path: indexG7R2Mya2P4Meta?.path ?? "/fr/admin",
    meta: indexG7R2Mya2P4Meta || {},
    alias: indexG7R2Mya2P4Meta?.alias || [],
    redirect: indexG7R2Mya2P4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexG7R2Mya2P4Meta?.name ?? "admin___nl",
    path: indexG7R2Mya2P4Meta?.path ?? "/nl/admin",
    meta: indexG7R2Mya2P4Meta || {},
    alias: indexG7R2Mya2P4Meta?.alias || [],
    redirect: indexG7R2Mya2P4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexG7R2Mya2P4Meta?.name ?? "admin___pt",
    path: indexG7R2Mya2P4Meta?.path ?? "/pt/admin",
    meta: indexG7R2Mya2P4Meta || {},
    alias: indexG7R2Mya2P4Meta?.alias || [],
    redirect: indexG7R2Mya2P4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: ordersTEuu2F15mdMeta?.name ?? "admin-orders___en",
    path: ordersTEuu2F15mdMeta?.path ?? "/admin/orders",
    meta: ordersTEuu2F15mdMeta || {},
    alias: ordersTEuu2F15mdMeta?.alias || [],
    redirect: ordersTEuu2F15mdMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/orders.vue").then(m => m.default || m)
  },
  {
    name: ordersTEuu2F15mdMeta?.name ?? "admin-orders___ja",
    path: ordersTEuu2F15mdMeta?.path ?? "/ja/admin/orders",
    meta: ordersTEuu2F15mdMeta || {},
    alias: ordersTEuu2F15mdMeta?.alias || [],
    redirect: ordersTEuu2F15mdMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/orders.vue").then(m => m.default || m)
  },
  {
    name: ordersTEuu2F15mdMeta?.name ?? "admin-orders___de",
    path: ordersTEuu2F15mdMeta?.path ?? "/de/admin/orders",
    meta: ordersTEuu2F15mdMeta || {},
    alias: ordersTEuu2F15mdMeta?.alias || [],
    redirect: ordersTEuu2F15mdMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/orders.vue").then(m => m.default || m)
  },
  {
    name: ordersTEuu2F15mdMeta?.name ?? "admin-orders___it",
    path: ordersTEuu2F15mdMeta?.path ?? "/it/admin/orders",
    meta: ordersTEuu2F15mdMeta || {},
    alias: ordersTEuu2F15mdMeta?.alias || [],
    redirect: ordersTEuu2F15mdMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/orders.vue").then(m => m.default || m)
  },
  {
    name: ordersTEuu2F15mdMeta?.name ?? "admin-orders___fr",
    path: ordersTEuu2F15mdMeta?.path ?? "/fr/admin/orders",
    meta: ordersTEuu2F15mdMeta || {},
    alias: ordersTEuu2F15mdMeta?.alias || [],
    redirect: ordersTEuu2F15mdMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/orders.vue").then(m => m.default || m)
  },
  {
    name: ordersTEuu2F15mdMeta?.name ?? "admin-orders___nl",
    path: ordersTEuu2F15mdMeta?.path ?? "/nl/admin/orders",
    meta: ordersTEuu2F15mdMeta || {},
    alias: ordersTEuu2F15mdMeta?.alias || [],
    redirect: ordersTEuu2F15mdMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/orders.vue").then(m => m.default || m)
  },
  {
    name: ordersTEuu2F15mdMeta?.name ?? "admin-orders___pt",
    path: ordersTEuu2F15mdMeta?.path ?? "/pt/admin/orders",
    meta: ordersTEuu2F15mdMeta || {},
    alias: ordersTEuu2F15mdMeta?.alias || [],
    redirect: ordersTEuu2F15mdMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/orders.vue").then(m => m.default || m)
  },
  {
    name: paymentsqWvZO2qmb3Meta?.name ?? "admin-payments___en",
    path: paymentsqWvZO2qmb3Meta?.path ?? "/admin/payments",
    meta: paymentsqWvZO2qmb3Meta || {},
    alias: paymentsqWvZO2qmb3Meta?.alias || [],
    redirect: paymentsqWvZO2qmb3Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/payments.vue").then(m => m.default || m)
  },
  {
    name: paymentsqWvZO2qmb3Meta?.name ?? "admin-payments___ja",
    path: paymentsqWvZO2qmb3Meta?.path ?? "/ja/admin/payments",
    meta: paymentsqWvZO2qmb3Meta || {},
    alias: paymentsqWvZO2qmb3Meta?.alias || [],
    redirect: paymentsqWvZO2qmb3Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/payments.vue").then(m => m.default || m)
  },
  {
    name: paymentsqWvZO2qmb3Meta?.name ?? "admin-payments___de",
    path: paymentsqWvZO2qmb3Meta?.path ?? "/de/admin/payments",
    meta: paymentsqWvZO2qmb3Meta || {},
    alias: paymentsqWvZO2qmb3Meta?.alias || [],
    redirect: paymentsqWvZO2qmb3Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/payments.vue").then(m => m.default || m)
  },
  {
    name: paymentsqWvZO2qmb3Meta?.name ?? "admin-payments___it",
    path: paymentsqWvZO2qmb3Meta?.path ?? "/it/admin/payments",
    meta: paymentsqWvZO2qmb3Meta || {},
    alias: paymentsqWvZO2qmb3Meta?.alias || [],
    redirect: paymentsqWvZO2qmb3Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/payments.vue").then(m => m.default || m)
  },
  {
    name: paymentsqWvZO2qmb3Meta?.name ?? "admin-payments___fr",
    path: paymentsqWvZO2qmb3Meta?.path ?? "/fr/admin/payments",
    meta: paymentsqWvZO2qmb3Meta || {},
    alias: paymentsqWvZO2qmb3Meta?.alias || [],
    redirect: paymentsqWvZO2qmb3Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/payments.vue").then(m => m.default || m)
  },
  {
    name: paymentsqWvZO2qmb3Meta?.name ?? "admin-payments___nl",
    path: paymentsqWvZO2qmb3Meta?.path ?? "/nl/admin/payments",
    meta: paymentsqWvZO2qmb3Meta || {},
    alias: paymentsqWvZO2qmb3Meta?.alias || [],
    redirect: paymentsqWvZO2qmb3Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/payments.vue").then(m => m.default || m)
  },
  {
    name: paymentsqWvZO2qmb3Meta?.name ?? "admin-payments___pt",
    path: paymentsqWvZO2qmb3Meta?.path ?? "/pt/admin/payments",
    meta: paymentsqWvZO2qmb3Meta || {},
    alias: paymentsqWvZO2qmb3Meta?.alias || [],
    redirect: paymentsqWvZO2qmb3Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/payments.vue").then(m => m.default || m)
  },
  {
    name: tasksfh2Qr4o982Meta?.name ?? "admin-tasks___en",
    path: tasksfh2Qr4o982Meta?.path ?? "/admin/tasks",
    meta: tasksfh2Qr4o982Meta || {},
    alias: tasksfh2Qr4o982Meta?.alias || [],
    redirect: tasksfh2Qr4o982Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/tasks.vue").then(m => m.default || m)
  },
  {
    name: tasksfh2Qr4o982Meta?.name ?? "admin-tasks___ja",
    path: tasksfh2Qr4o982Meta?.path ?? "/ja/admin/tasks",
    meta: tasksfh2Qr4o982Meta || {},
    alias: tasksfh2Qr4o982Meta?.alias || [],
    redirect: tasksfh2Qr4o982Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/tasks.vue").then(m => m.default || m)
  },
  {
    name: tasksfh2Qr4o982Meta?.name ?? "admin-tasks___de",
    path: tasksfh2Qr4o982Meta?.path ?? "/de/admin/tasks",
    meta: tasksfh2Qr4o982Meta || {},
    alias: tasksfh2Qr4o982Meta?.alias || [],
    redirect: tasksfh2Qr4o982Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/tasks.vue").then(m => m.default || m)
  },
  {
    name: tasksfh2Qr4o982Meta?.name ?? "admin-tasks___it",
    path: tasksfh2Qr4o982Meta?.path ?? "/it/admin/tasks",
    meta: tasksfh2Qr4o982Meta || {},
    alias: tasksfh2Qr4o982Meta?.alias || [],
    redirect: tasksfh2Qr4o982Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/tasks.vue").then(m => m.default || m)
  },
  {
    name: tasksfh2Qr4o982Meta?.name ?? "admin-tasks___fr",
    path: tasksfh2Qr4o982Meta?.path ?? "/fr/admin/tasks",
    meta: tasksfh2Qr4o982Meta || {},
    alias: tasksfh2Qr4o982Meta?.alias || [],
    redirect: tasksfh2Qr4o982Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/tasks.vue").then(m => m.default || m)
  },
  {
    name: tasksfh2Qr4o982Meta?.name ?? "admin-tasks___nl",
    path: tasksfh2Qr4o982Meta?.path ?? "/nl/admin/tasks",
    meta: tasksfh2Qr4o982Meta || {},
    alias: tasksfh2Qr4o982Meta?.alias || [],
    redirect: tasksfh2Qr4o982Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/tasks.vue").then(m => m.default || m)
  },
  {
    name: tasksfh2Qr4o982Meta?.name ?? "admin-tasks___pt",
    path: tasksfh2Qr4o982Meta?.path ?? "/pt/admin/tasks",
    meta: tasksfh2Qr4o982Meta || {},
    alias: tasksfh2Qr4o982Meta?.alias || [],
    redirect: tasksfh2Qr4o982Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/tasks.vue").then(m => m.default || m)
  },
  {
    name: usersjvZRxTajERMeta?.name ?? "admin-users___en",
    path: usersjvZRxTajERMeta?.path ?? "/admin/users",
    meta: usersjvZRxTajERMeta || {},
    alias: usersjvZRxTajERMeta?.alias || [],
    redirect: usersjvZRxTajERMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/users.vue").then(m => m.default || m)
  },
  {
    name: usersjvZRxTajERMeta?.name ?? "admin-users___ja",
    path: usersjvZRxTajERMeta?.path ?? "/ja/admin/users",
    meta: usersjvZRxTajERMeta || {},
    alias: usersjvZRxTajERMeta?.alias || [],
    redirect: usersjvZRxTajERMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/users.vue").then(m => m.default || m)
  },
  {
    name: usersjvZRxTajERMeta?.name ?? "admin-users___de",
    path: usersjvZRxTajERMeta?.path ?? "/de/admin/users",
    meta: usersjvZRxTajERMeta || {},
    alias: usersjvZRxTajERMeta?.alias || [],
    redirect: usersjvZRxTajERMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/users.vue").then(m => m.default || m)
  },
  {
    name: usersjvZRxTajERMeta?.name ?? "admin-users___it",
    path: usersjvZRxTajERMeta?.path ?? "/it/admin/users",
    meta: usersjvZRxTajERMeta || {},
    alias: usersjvZRxTajERMeta?.alias || [],
    redirect: usersjvZRxTajERMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/users.vue").then(m => m.default || m)
  },
  {
    name: usersjvZRxTajERMeta?.name ?? "admin-users___fr",
    path: usersjvZRxTajERMeta?.path ?? "/fr/admin/users",
    meta: usersjvZRxTajERMeta || {},
    alias: usersjvZRxTajERMeta?.alias || [],
    redirect: usersjvZRxTajERMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/users.vue").then(m => m.default || m)
  },
  {
    name: usersjvZRxTajERMeta?.name ?? "admin-users___nl",
    path: usersjvZRxTajERMeta?.path ?? "/nl/admin/users",
    meta: usersjvZRxTajERMeta || {},
    alias: usersjvZRxTajERMeta?.alias || [],
    redirect: usersjvZRxTajERMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/users.vue").then(m => m.default || m)
  },
  {
    name: usersjvZRxTajERMeta?.name ?? "admin-users___pt",
    path: usersjvZRxTajERMeta?.path ?? "/pt/admin/users",
    meta: usersjvZRxTajERMeta || {},
    alias: usersjvZRxTajERMeta?.alias || [],
    redirect: usersjvZRxTajERMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/users.vue").then(m => m.default || m)
  },
  {
    name: ai_45poseWfCVbdfCgyMeta?.name ?? "ai-pose___en",
    path: ai_45poseWfCVbdfCgyMeta?.path ?? "/ai-pose",
    meta: ai_45poseWfCVbdfCgyMeta || {},
    alias: ai_45poseWfCVbdfCgyMeta?.alias || [],
    redirect: ai_45poseWfCVbdfCgyMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-pose.vue").then(m => m.default || m)
  },
  {
    name: ai_45poseWfCVbdfCgyMeta?.name ?? "ai-pose___ja",
    path: ai_45poseWfCVbdfCgyMeta?.path ?? "/ja/ai-pose",
    meta: ai_45poseWfCVbdfCgyMeta || {},
    alias: ai_45poseWfCVbdfCgyMeta?.alias || [],
    redirect: ai_45poseWfCVbdfCgyMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-pose.vue").then(m => m.default || m)
  },
  {
    name: ai_45poseWfCVbdfCgyMeta?.name ?? "ai-pose___de",
    path: ai_45poseWfCVbdfCgyMeta?.path ?? "/de/ai-pose",
    meta: ai_45poseWfCVbdfCgyMeta || {},
    alias: ai_45poseWfCVbdfCgyMeta?.alias || [],
    redirect: ai_45poseWfCVbdfCgyMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-pose.vue").then(m => m.default || m)
  },
  {
    name: ai_45poseWfCVbdfCgyMeta?.name ?? "ai-pose___it",
    path: ai_45poseWfCVbdfCgyMeta?.path ?? "/it/ai-pose",
    meta: ai_45poseWfCVbdfCgyMeta || {},
    alias: ai_45poseWfCVbdfCgyMeta?.alias || [],
    redirect: ai_45poseWfCVbdfCgyMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-pose.vue").then(m => m.default || m)
  },
  {
    name: ai_45poseWfCVbdfCgyMeta?.name ?? "ai-pose___fr",
    path: ai_45poseWfCVbdfCgyMeta?.path ?? "/fr/ai-pose",
    meta: ai_45poseWfCVbdfCgyMeta || {},
    alias: ai_45poseWfCVbdfCgyMeta?.alias || [],
    redirect: ai_45poseWfCVbdfCgyMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-pose.vue").then(m => m.default || m)
  },
  {
    name: ai_45poseWfCVbdfCgyMeta?.name ?? "ai-pose___nl",
    path: ai_45poseWfCVbdfCgyMeta?.path ?? "/nl/ai-pose",
    meta: ai_45poseWfCVbdfCgyMeta || {},
    alias: ai_45poseWfCVbdfCgyMeta?.alias || [],
    redirect: ai_45poseWfCVbdfCgyMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-pose.vue").then(m => m.default || m)
  },
  {
    name: ai_45poseWfCVbdfCgyMeta?.name ?? "ai-pose___pt",
    path: ai_45poseWfCVbdfCgyMeta?.path ?? "/pt/ai-pose",
    meta: ai_45poseWfCVbdfCgyMeta || {},
    alias: ai_45poseWfCVbdfCgyMeta?.alias || [],
    redirect: ai_45poseWfCVbdfCgyMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-pose.vue").then(m => m.default || m)
  },
  {
    name: ai_45videoCRnd3c2MPsMeta?.name ?? "ai-video___en",
    path: ai_45videoCRnd3c2MPsMeta?.path ?? "/ai-video",
    meta: ai_45videoCRnd3c2MPsMeta || {},
    alias: ai_45videoCRnd3c2MPsMeta?.alias || [],
    redirect: ai_45videoCRnd3c2MPsMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-video.vue").then(m => m.default || m)
  },
  {
    name: ai_45videoCRnd3c2MPsMeta?.name ?? "ai-video___ja",
    path: ai_45videoCRnd3c2MPsMeta?.path ?? "/ja/ai-video",
    meta: ai_45videoCRnd3c2MPsMeta || {},
    alias: ai_45videoCRnd3c2MPsMeta?.alias || [],
    redirect: ai_45videoCRnd3c2MPsMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-video.vue").then(m => m.default || m)
  },
  {
    name: ai_45videoCRnd3c2MPsMeta?.name ?? "ai-video___de",
    path: ai_45videoCRnd3c2MPsMeta?.path ?? "/de/ai-video",
    meta: ai_45videoCRnd3c2MPsMeta || {},
    alias: ai_45videoCRnd3c2MPsMeta?.alias || [],
    redirect: ai_45videoCRnd3c2MPsMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-video.vue").then(m => m.default || m)
  },
  {
    name: ai_45videoCRnd3c2MPsMeta?.name ?? "ai-video___it",
    path: ai_45videoCRnd3c2MPsMeta?.path ?? "/it/ai-video",
    meta: ai_45videoCRnd3c2MPsMeta || {},
    alias: ai_45videoCRnd3c2MPsMeta?.alias || [],
    redirect: ai_45videoCRnd3c2MPsMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-video.vue").then(m => m.default || m)
  },
  {
    name: ai_45videoCRnd3c2MPsMeta?.name ?? "ai-video___fr",
    path: ai_45videoCRnd3c2MPsMeta?.path ?? "/fr/ai-video",
    meta: ai_45videoCRnd3c2MPsMeta || {},
    alias: ai_45videoCRnd3c2MPsMeta?.alias || [],
    redirect: ai_45videoCRnd3c2MPsMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-video.vue").then(m => m.default || m)
  },
  {
    name: ai_45videoCRnd3c2MPsMeta?.name ?? "ai-video___nl",
    path: ai_45videoCRnd3c2MPsMeta?.path ?? "/nl/ai-video",
    meta: ai_45videoCRnd3c2MPsMeta || {},
    alias: ai_45videoCRnd3c2MPsMeta?.alias || [],
    redirect: ai_45videoCRnd3c2MPsMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-video.vue").then(m => m.default || m)
  },
  {
    name: ai_45videoCRnd3c2MPsMeta?.name ?? "ai-video___pt",
    path: ai_45videoCRnd3c2MPsMeta?.path ?? "/pt/ai-video",
    meta: ai_45videoCRnd3c2MPsMeta || {},
    alias: ai_45videoCRnd3c2MPsMeta?.alias || [],
    redirect: ai_45videoCRnd3c2MPsMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/ai-video.vue").then(m => m.default || m)
  },
  {
    name: checkoutlZQLvi17ODMeta?.name ?? "checkout___en",
    path: checkoutlZQLvi17ODMeta?.path ?? "/checkout",
    meta: checkoutlZQLvi17ODMeta || {},
    alias: checkoutlZQLvi17ODMeta?.alias || [],
    redirect: checkoutlZQLvi17ODMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: checkoutlZQLvi17ODMeta?.name ?? "checkout___ja",
    path: checkoutlZQLvi17ODMeta?.path ?? "/ja/checkout",
    meta: checkoutlZQLvi17ODMeta || {},
    alias: checkoutlZQLvi17ODMeta?.alias || [],
    redirect: checkoutlZQLvi17ODMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: checkoutlZQLvi17ODMeta?.name ?? "checkout___de",
    path: checkoutlZQLvi17ODMeta?.path ?? "/de/checkout",
    meta: checkoutlZQLvi17ODMeta || {},
    alias: checkoutlZQLvi17ODMeta?.alias || [],
    redirect: checkoutlZQLvi17ODMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: checkoutlZQLvi17ODMeta?.name ?? "checkout___it",
    path: checkoutlZQLvi17ODMeta?.path ?? "/it/checkout",
    meta: checkoutlZQLvi17ODMeta || {},
    alias: checkoutlZQLvi17ODMeta?.alias || [],
    redirect: checkoutlZQLvi17ODMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: checkoutlZQLvi17ODMeta?.name ?? "checkout___fr",
    path: checkoutlZQLvi17ODMeta?.path ?? "/fr/checkout",
    meta: checkoutlZQLvi17ODMeta || {},
    alias: checkoutlZQLvi17ODMeta?.alias || [],
    redirect: checkoutlZQLvi17ODMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: checkoutlZQLvi17ODMeta?.name ?? "checkout___nl",
    path: checkoutlZQLvi17ODMeta?.path ?? "/nl/checkout",
    meta: checkoutlZQLvi17ODMeta || {},
    alias: checkoutlZQLvi17ODMeta?.alias || [],
    redirect: checkoutlZQLvi17ODMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: checkoutlZQLvi17ODMeta?.name ?? "checkout___pt",
    path: checkoutlZQLvi17ODMeta?.path ?? "/pt/checkout",
    meta: checkoutlZQLvi17ODMeta || {},
    alias: checkoutlZQLvi17ODMeta?.alias || [],
    redirect: checkoutlZQLvi17ODMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: contactJnsDpYVejzMeta?.name ?? "contact___en",
    path: contactJnsDpYVejzMeta?.path ?? "/contact",
    meta: contactJnsDpYVejzMeta || {},
    alias: contactJnsDpYVejzMeta?.alias || [],
    redirect: contactJnsDpYVejzMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactJnsDpYVejzMeta?.name ?? "contact___ja",
    path: contactJnsDpYVejzMeta?.path ?? "/ja/contact",
    meta: contactJnsDpYVejzMeta || {},
    alias: contactJnsDpYVejzMeta?.alias || [],
    redirect: contactJnsDpYVejzMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactJnsDpYVejzMeta?.name ?? "contact___de",
    path: contactJnsDpYVejzMeta?.path ?? "/de/contact",
    meta: contactJnsDpYVejzMeta || {},
    alias: contactJnsDpYVejzMeta?.alias || [],
    redirect: contactJnsDpYVejzMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactJnsDpYVejzMeta?.name ?? "contact___it",
    path: contactJnsDpYVejzMeta?.path ?? "/it/contact",
    meta: contactJnsDpYVejzMeta || {},
    alias: contactJnsDpYVejzMeta?.alias || [],
    redirect: contactJnsDpYVejzMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactJnsDpYVejzMeta?.name ?? "contact___fr",
    path: contactJnsDpYVejzMeta?.path ?? "/fr/contact",
    meta: contactJnsDpYVejzMeta || {},
    alias: contactJnsDpYVejzMeta?.alias || [],
    redirect: contactJnsDpYVejzMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactJnsDpYVejzMeta?.name ?? "contact___nl",
    path: contactJnsDpYVejzMeta?.path ?? "/nl/contact",
    meta: contactJnsDpYVejzMeta || {},
    alias: contactJnsDpYVejzMeta?.alias || [],
    redirect: contactJnsDpYVejzMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactJnsDpYVejzMeta?.name ?? "contact___pt",
    path: contactJnsDpYVejzMeta?.path ?? "/pt/contact",
    meta: contactJnsDpYVejzMeta || {},
    alias: contactJnsDpYVejzMeta?.alias || [],
    redirect: contactJnsDpYVejzMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: content_45monitoring_45policyd3f6ehtswWMeta?.name ?? "content-monitoring-policy___en",
    path: content_45monitoring_45policyd3f6ehtswWMeta?.path ?? "/content-monitoring-policy",
    meta: content_45monitoring_45policyd3f6ehtswWMeta || {},
    alias: content_45monitoring_45policyd3f6ehtswWMeta?.alias || [],
    redirect: content_45monitoring_45policyd3f6ehtswWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/content-monitoring-policy.vue").then(m => m.default || m)
  },
  {
    name: content_45monitoring_45policyd3f6ehtswWMeta?.name ?? "content-monitoring-policy___ja",
    path: content_45monitoring_45policyd3f6ehtswWMeta?.path ?? "/ja/content-monitoring-policy",
    meta: content_45monitoring_45policyd3f6ehtswWMeta || {},
    alias: content_45monitoring_45policyd3f6ehtswWMeta?.alias || [],
    redirect: content_45monitoring_45policyd3f6ehtswWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/content-monitoring-policy.vue").then(m => m.default || m)
  },
  {
    name: content_45monitoring_45policyd3f6ehtswWMeta?.name ?? "content-monitoring-policy___de",
    path: content_45monitoring_45policyd3f6ehtswWMeta?.path ?? "/de/content-monitoring-policy",
    meta: content_45monitoring_45policyd3f6ehtswWMeta || {},
    alias: content_45monitoring_45policyd3f6ehtswWMeta?.alias || [],
    redirect: content_45monitoring_45policyd3f6ehtswWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/content-monitoring-policy.vue").then(m => m.default || m)
  },
  {
    name: content_45monitoring_45policyd3f6ehtswWMeta?.name ?? "content-monitoring-policy___it",
    path: content_45monitoring_45policyd3f6ehtswWMeta?.path ?? "/it/content-monitoring-policy",
    meta: content_45monitoring_45policyd3f6ehtswWMeta || {},
    alias: content_45monitoring_45policyd3f6ehtswWMeta?.alias || [],
    redirect: content_45monitoring_45policyd3f6ehtswWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/content-monitoring-policy.vue").then(m => m.default || m)
  },
  {
    name: content_45monitoring_45policyd3f6ehtswWMeta?.name ?? "content-monitoring-policy___fr",
    path: content_45monitoring_45policyd3f6ehtswWMeta?.path ?? "/fr/content-monitoring-policy",
    meta: content_45monitoring_45policyd3f6ehtswWMeta || {},
    alias: content_45monitoring_45policyd3f6ehtswWMeta?.alias || [],
    redirect: content_45monitoring_45policyd3f6ehtswWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/content-monitoring-policy.vue").then(m => m.default || m)
  },
  {
    name: content_45monitoring_45policyd3f6ehtswWMeta?.name ?? "content-monitoring-policy___nl",
    path: content_45monitoring_45policyd3f6ehtswWMeta?.path ?? "/nl/content-monitoring-policy",
    meta: content_45monitoring_45policyd3f6ehtswWMeta || {},
    alias: content_45monitoring_45policyd3f6ehtswWMeta?.alias || [],
    redirect: content_45monitoring_45policyd3f6ehtswWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/content-monitoring-policy.vue").then(m => m.default || m)
  },
  {
    name: content_45monitoring_45policyd3f6ehtswWMeta?.name ?? "content-monitoring-policy___pt",
    path: content_45monitoring_45policyd3f6ehtswWMeta?.path ?? "/pt/content-monitoring-policy",
    meta: content_45monitoring_45policyd3f6ehtswWMeta || {},
    alias: content_45monitoring_45policyd3f6ehtswWMeta?.alias || [],
    redirect: content_45monitoring_45policyd3f6ehtswWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/content-monitoring-policy.vue").then(m => m.default || m)
  },
  {
    name: creation_detail0bpyLZFDn6Meta?.name ?? "creation_detail___en",
    path: creation_detail0bpyLZFDn6Meta?.path ?? "/creation_detail",
    meta: creation_detail0bpyLZFDn6Meta || {},
    alias: creation_detail0bpyLZFDn6Meta?.alias || [],
    redirect: creation_detail0bpyLZFDn6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/creation_detail.vue").then(m => m.default || m)
  },
  {
    name: creation_detail0bpyLZFDn6Meta?.name ?? "creation_detail___ja",
    path: creation_detail0bpyLZFDn6Meta?.path ?? "/ja/creation_detail",
    meta: creation_detail0bpyLZFDn6Meta || {},
    alias: creation_detail0bpyLZFDn6Meta?.alias || [],
    redirect: creation_detail0bpyLZFDn6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/creation_detail.vue").then(m => m.default || m)
  },
  {
    name: creation_detail0bpyLZFDn6Meta?.name ?? "creation_detail___de",
    path: creation_detail0bpyLZFDn6Meta?.path ?? "/de/creation_detail",
    meta: creation_detail0bpyLZFDn6Meta || {},
    alias: creation_detail0bpyLZFDn6Meta?.alias || [],
    redirect: creation_detail0bpyLZFDn6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/creation_detail.vue").then(m => m.default || m)
  },
  {
    name: creation_detail0bpyLZFDn6Meta?.name ?? "creation_detail___it",
    path: creation_detail0bpyLZFDn6Meta?.path ?? "/it/creation_detail",
    meta: creation_detail0bpyLZFDn6Meta || {},
    alias: creation_detail0bpyLZFDn6Meta?.alias || [],
    redirect: creation_detail0bpyLZFDn6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/creation_detail.vue").then(m => m.default || m)
  },
  {
    name: creation_detail0bpyLZFDn6Meta?.name ?? "creation_detail___fr",
    path: creation_detail0bpyLZFDn6Meta?.path ?? "/fr/creation_detail",
    meta: creation_detail0bpyLZFDn6Meta || {},
    alias: creation_detail0bpyLZFDn6Meta?.alias || [],
    redirect: creation_detail0bpyLZFDn6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/creation_detail.vue").then(m => m.default || m)
  },
  {
    name: creation_detail0bpyLZFDn6Meta?.name ?? "creation_detail___nl",
    path: creation_detail0bpyLZFDn6Meta?.path ?? "/nl/creation_detail",
    meta: creation_detail0bpyLZFDn6Meta || {},
    alias: creation_detail0bpyLZFDn6Meta?.alias || [],
    redirect: creation_detail0bpyLZFDn6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/creation_detail.vue").then(m => m.default || m)
  },
  {
    name: creation_detail0bpyLZFDn6Meta?.name ?? "creation_detail___pt",
    path: creation_detail0bpyLZFDn6Meta?.path ?? "/pt/creation_detail",
    meta: creation_detail0bpyLZFDn6Meta || {},
    alias: creation_detail0bpyLZFDn6Meta?.alias || [],
    redirect: creation_detail0bpyLZFDn6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/creation_detail.vue").then(m => m.default || m)
  },
  {
    name: editor28b1wOPw0RMeta?.name ?? "editor___en",
    path: editor28b1wOPw0RMeta?.path ?? "/editor",
    meta: editor28b1wOPw0RMeta || {},
    alias: editor28b1wOPw0RMeta?.alias || [],
    redirect: editor28b1wOPw0RMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/editor.vue").then(m => m.default || m)
  },
  {
    name: editor28b1wOPw0RMeta?.name ?? "editor___ja",
    path: editor28b1wOPw0RMeta?.path ?? "/ja/editor",
    meta: editor28b1wOPw0RMeta || {},
    alias: editor28b1wOPw0RMeta?.alias || [],
    redirect: editor28b1wOPw0RMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/editor.vue").then(m => m.default || m)
  },
  {
    name: editor28b1wOPw0RMeta?.name ?? "editor___de",
    path: editor28b1wOPw0RMeta?.path ?? "/de/editor",
    meta: editor28b1wOPw0RMeta || {},
    alias: editor28b1wOPw0RMeta?.alias || [],
    redirect: editor28b1wOPw0RMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/editor.vue").then(m => m.default || m)
  },
  {
    name: editor28b1wOPw0RMeta?.name ?? "editor___it",
    path: editor28b1wOPw0RMeta?.path ?? "/it/editor",
    meta: editor28b1wOPw0RMeta || {},
    alias: editor28b1wOPw0RMeta?.alias || [],
    redirect: editor28b1wOPw0RMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/editor.vue").then(m => m.default || m)
  },
  {
    name: editor28b1wOPw0RMeta?.name ?? "editor___fr",
    path: editor28b1wOPw0RMeta?.path ?? "/fr/editor",
    meta: editor28b1wOPw0RMeta || {},
    alias: editor28b1wOPw0RMeta?.alias || [],
    redirect: editor28b1wOPw0RMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/editor.vue").then(m => m.default || m)
  },
  {
    name: editor28b1wOPw0RMeta?.name ?? "editor___nl",
    path: editor28b1wOPw0RMeta?.path ?? "/nl/editor",
    meta: editor28b1wOPw0RMeta || {},
    alias: editor28b1wOPw0RMeta?.alias || [],
    redirect: editor28b1wOPw0RMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/editor.vue").then(m => m.default || m)
  },
  {
    name: editor28b1wOPw0RMeta?.name ?? "editor___pt",
    path: editor28b1wOPw0RMeta?.path ?? "/pt/editor",
    meta: editor28b1wOPw0RMeta || {},
    alias: editor28b1wOPw0RMeta?.alias || [],
    redirect: editor28b1wOPw0RMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/editor.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45photowVOTMvKAwaMeta?.name ?? "face-swap-photo___en",
    path: face_45swap_45photowVOTMvKAwaMeta?.path ?? "/face-swap-photo",
    meta: face_45swap_45photowVOTMvKAwaMeta || {},
    alias: face_45swap_45photowVOTMvKAwaMeta?.alias || [],
    redirect: face_45swap_45photowVOTMvKAwaMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-photo.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45photowVOTMvKAwaMeta?.name ?? "face-swap-photo___ja",
    path: face_45swap_45photowVOTMvKAwaMeta?.path ?? "/ja/face-swap-photo",
    meta: face_45swap_45photowVOTMvKAwaMeta || {},
    alias: face_45swap_45photowVOTMvKAwaMeta?.alias || [],
    redirect: face_45swap_45photowVOTMvKAwaMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-photo.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45photowVOTMvKAwaMeta?.name ?? "face-swap-photo___de",
    path: face_45swap_45photowVOTMvKAwaMeta?.path ?? "/de/face-swap-photo",
    meta: face_45swap_45photowVOTMvKAwaMeta || {},
    alias: face_45swap_45photowVOTMvKAwaMeta?.alias || [],
    redirect: face_45swap_45photowVOTMvKAwaMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-photo.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45photowVOTMvKAwaMeta?.name ?? "face-swap-photo___it",
    path: face_45swap_45photowVOTMvKAwaMeta?.path ?? "/it/face-swap-photo",
    meta: face_45swap_45photowVOTMvKAwaMeta || {},
    alias: face_45swap_45photowVOTMvKAwaMeta?.alias || [],
    redirect: face_45swap_45photowVOTMvKAwaMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-photo.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45photowVOTMvKAwaMeta?.name ?? "face-swap-photo___fr",
    path: face_45swap_45photowVOTMvKAwaMeta?.path ?? "/fr/face-swap-photo",
    meta: face_45swap_45photowVOTMvKAwaMeta || {},
    alias: face_45swap_45photowVOTMvKAwaMeta?.alias || [],
    redirect: face_45swap_45photowVOTMvKAwaMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-photo.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45photowVOTMvKAwaMeta?.name ?? "face-swap-photo___nl",
    path: face_45swap_45photowVOTMvKAwaMeta?.path ?? "/nl/face-swap-photo",
    meta: face_45swap_45photowVOTMvKAwaMeta || {},
    alias: face_45swap_45photowVOTMvKAwaMeta?.alias || [],
    redirect: face_45swap_45photowVOTMvKAwaMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-photo.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45photowVOTMvKAwaMeta?.name ?? "face-swap-photo___pt",
    path: face_45swap_45photowVOTMvKAwaMeta?.path ?? "/pt/face-swap-photo",
    meta: face_45swap_45photowVOTMvKAwaMeta || {},
    alias: face_45swap_45photowVOTMvKAwaMeta?.alias || [],
    redirect: face_45swap_45photowVOTMvKAwaMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-photo.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45videoGyoUkhjUB2Meta?.name ?? "face-swap-video___en",
    path: face_45swap_45videoGyoUkhjUB2Meta?.path ?? "/face-swap-video",
    meta: face_45swap_45videoGyoUkhjUB2Meta || {},
    alias: face_45swap_45videoGyoUkhjUB2Meta?.alias || [],
    redirect: face_45swap_45videoGyoUkhjUB2Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-video.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45videoGyoUkhjUB2Meta?.name ?? "face-swap-video___ja",
    path: face_45swap_45videoGyoUkhjUB2Meta?.path ?? "/ja/face-swap-video",
    meta: face_45swap_45videoGyoUkhjUB2Meta || {},
    alias: face_45swap_45videoGyoUkhjUB2Meta?.alias || [],
    redirect: face_45swap_45videoGyoUkhjUB2Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-video.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45videoGyoUkhjUB2Meta?.name ?? "face-swap-video___de",
    path: face_45swap_45videoGyoUkhjUB2Meta?.path ?? "/de/face-swap-video",
    meta: face_45swap_45videoGyoUkhjUB2Meta || {},
    alias: face_45swap_45videoGyoUkhjUB2Meta?.alias || [],
    redirect: face_45swap_45videoGyoUkhjUB2Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-video.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45videoGyoUkhjUB2Meta?.name ?? "face-swap-video___it",
    path: face_45swap_45videoGyoUkhjUB2Meta?.path ?? "/it/face-swap-video",
    meta: face_45swap_45videoGyoUkhjUB2Meta || {},
    alias: face_45swap_45videoGyoUkhjUB2Meta?.alias || [],
    redirect: face_45swap_45videoGyoUkhjUB2Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-video.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45videoGyoUkhjUB2Meta?.name ?? "face-swap-video___fr",
    path: face_45swap_45videoGyoUkhjUB2Meta?.path ?? "/fr/face-swap-video",
    meta: face_45swap_45videoGyoUkhjUB2Meta || {},
    alias: face_45swap_45videoGyoUkhjUB2Meta?.alias || [],
    redirect: face_45swap_45videoGyoUkhjUB2Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-video.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45videoGyoUkhjUB2Meta?.name ?? "face-swap-video___nl",
    path: face_45swap_45videoGyoUkhjUB2Meta?.path ?? "/nl/face-swap-video",
    meta: face_45swap_45videoGyoUkhjUB2Meta || {},
    alias: face_45swap_45videoGyoUkhjUB2Meta?.alias || [],
    redirect: face_45swap_45videoGyoUkhjUB2Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-video.vue").then(m => m.default || m)
  },
  {
    name: face_45swap_45videoGyoUkhjUB2Meta?.name ?? "face-swap-video___pt",
    path: face_45swap_45videoGyoUkhjUB2Meta?.path ?? "/pt/face-swap-video",
    meta: face_45swap_45videoGyoUkhjUB2Meta || {},
    alias: face_45swap_45videoGyoUkhjUB2Meta?.alias || [],
    redirect: face_45swap_45videoGyoUkhjUB2Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap-video.vue").then(m => m.default || m)
  },
  {
    name: face_45swapgJYtqBo06tMeta?.name ?? "face-swap___en",
    path: face_45swapgJYtqBo06tMeta?.path ?? "/face-swap",
    meta: face_45swapgJYtqBo06tMeta || {},
    alias: face_45swapgJYtqBo06tMeta?.alias || [],
    redirect: face_45swapgJYtqBo06tMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap.vue").then(m => m.default || m)
  },
  {
    name: face_45swapgJYtqBo06tMeta?.name ?? "face-swap___ja",
    path: face_45swapgJYtqBo06tMeta?.path ?? "/ja/face-swap",
    meta: face_45swapgJYtqBo06tMeta || {},
    alias: face_45swapgJYtqBo06tMeta?.alias || [],
    redirect: face_45swapgJYtqBo06tMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap.vue").then(m => m.default || m)
  },
  {
    name: face_45swapgJYtqBo06tMeta?.name ?? "face-swap___de",
    path: face_45swapgJYtqBo06tMeta?.path ?? "/de/face-swap",
    meta: face_45swapgJYtqBo06tMeta || {},
    alias: face_45swapgJYtqBo06tMeta?.alias || [],
    redirect: face_45swapgJYtqBo06tMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap.vue").then(m => m.default || m)
  },
  {
    name: face_45swapgJYtqBo06tMeta?.name ?? "face-swap___it",
    path: face_45swapgJYtqBo06tMeta?.path ?? "/it/face-swap",
    meta: face_45swapgJYtqBo06tMeta || {},
    alias: face_45swapgJYtqBo06tMeta?.alias || [],
    redirect: face_45swapgJYtqBo06tMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap.vue").then(m => m.default || m)
  },
  {
    name: face_45swapgJYtqBo06tMeta?.name ?? "face-swap___fr",
    path: face_45swapgJYtqBo06tMeta?.path ?? "/fr/face-swap",
    meta: face_45swapgJYtqBo06tMeta || {},
    alias: face_45swapgJYtqBo06tMeta?.alias || [],
    redirect: face_45swapgJYtqBo06tMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap.vue").then(m => m.default || m)
  },
  {
    name: face_45swapgJYtqBo06tMeta?.name ?? "face-swap___nl",
    path: face_45swapgJYtqBo06tMeta?.path ?? "/nl/face-swap",
    meta: face_45swapgJYtqBo06tMeta || {},
    alias: face_45swapgJYtqBo06tMeta?.alias || [],
    redirect: face_45swapgJYtqBo06tMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap.vue").then(m => m.default || m)
  },
  {
    name: face_45swapgJYtqBo06tMeta?.name ?? "face-swap___pt",
    path: face_45swapgJYtqBo06tMeta?.path ?? "/pt/face-swap",
    meta: face_45swapgJYtqBo06tMeta || {},
    alias: face_45swapgJYtqBo06tMeta?.alias || [],
    redirect: face_45swapgJYtqBo06tMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/face-swap.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___en",
    path: indexe9Brt5DfdhMeta?.path ?? "/",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___ja",
    path: indexe9Brt5DfdhMeta?.path ?? "/ja",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___de",
    path: indexe9Brt5DfdhMeta?.path ?? "/de",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___it",
    path: indexe9Brt5DfdhMeta?.path ?? "/it",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___fr",
    path: indexe9Brt5DfdhMeta?.path ?? "/fr",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___nl",
    path: indexe9Brt5DfdhMeta?.path ?? "/nl",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index___pt",
    path: indexe9Brt5DfdhMeta?.path ?? "/pt",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91_91site_93_93f0F0e6ZtvBMeta?.name ?? "login-site___en",
    path: _91_91site_93_93f0F0e6ZtvBMeta?.path ?? "/login/:site?",
    meta: _91_91site_93_93f0F0e6ZtvBMeta || {},
    alias: _91_91site_93_93f0F0e6ZtvBMeta?.alias || [],
    redirect: _91_91site_93_93f0F0e6ZtvBMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/login/[[site]].vue").then(m => m.default || m)
  },
  {
    name: _91_91site_93_93f0F0e6ZtvBMeta?.name ?? "login-site___ja",
    path: _91_91site_93_93f0F0e6ZtvBMeta?.path ?? "/ja/login/:site?",
    meta: _91_91site_93_93f0F0e6ZtvBMeta || {},
    alias: _91_91site_93_93f0F0e6ZtvBMeta?.alias || [],
    redirect: _91_91site_93_93f0F0e6ZtvBMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/login/[[site]].vue").then(m => m.default || m)
  },
  {
    name: _91_91site_93_93f0F0e6ZtvBMeta?.name ?? "login-site___de",
    path: _91_91site_93_93f0F0e6ZtvBMeta?.path ?? "/de/login/:site?",
    meta: _91_91site_93_93f0F0e6ZtvBMeta || {},
    alias: _91_91site_93_93f0F0e6ZtvBMeta?.alias || [],
    redirect: _91_91site_93_93f0F0e6ZtvBMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/login/[[site]].vue").then(m => m.default || m)
  },
  {
    name: _91_91site_93_93f0F0e6ZtvBMeta?.name ?? "login-site___it",
    path: _91_91site_93_93f0F0e6ZtvBMeta?.path ?? "/it/login/:site?",
    meta: _91_91site_93_93f0F0e6ZtvBMeta || {},
    alias: _91_91site_93_93f0F0e6ZtvBMeta?.alias || [],
    redirect: _91_91site_93_93f0F0e6ZtvBMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/login/[[site]].vue").then(m => m.default || m)
  },
  {
    name: _91_91site_93_93f0F0e6ZtvBMeta?.name ?? "login-site___fr",
    path: _91_91site_93_93f0F0e6ZtvBMeta?.path ?? "/fr/login/:site?",
    meta: _91_91site_93_93f0F0e6ZtvBMeta || {},
    alias: _91_91site_93_93f0F0e6ZtvBMeta?.alias || [],
    redirect: _91_91site_93_93f0F0e6ZtvBMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/login/[[site]].vue").then(m => m.default || m)
  },
  {
    name: _91_91site_93_93f0F0e6ZtvBMeta?.name ?? "login-site___nl",
    path: _91_91site_93_93f0F0e6ZtvBMeta?.path ?? "/nl/login/:site?",
    meta: _91_91site_93_93f0F0e6ZtvBMeta || {},
    alias: _91_91site_93_93f0F0e6ZtvBMeta?.alias || [],
    redirect: _91_91site_93_93f0F0e6ZtvBMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/login/[[site]].vue").then(m => m.default || m)
  },
  {
    name: _91_91site_93_93f0F0e6ZtvBMeta?.name ?? "login-site___pt",
    path: _91_91site_93_93f0F0e6ZtvBMeta?.path ?? "/pt/login/:site?",
    meta: _91_91site_93_93f0F0e6ZtvBMeta || {},
    alias: _91_91site_93_93f0F0e6ZtvBMeta?.alias || [],
    redirect: _91_91site_93_93f0F0e6ZtvBMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/login/[[site]].vue").then(m => m.default || m)
  },
  {
    name: my0dargHxM6iMeta?.name ?? "my___en",
    path: my0dargHxM6iMeta?.path ?? "/my",
    children: [
  {
    name: accountzGIuhQIyqWMeta?.name ?? "my-account___en",
    path: accountzGIuhQIyqWMeta?.path ?? "account",
    meta: accountzGIuhQIyqWMeta || {},
    alias: accountzGIuhQIyqWMeta?.alias || [],
    redirect: accountzGIuhQIyqWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/account.vue").then(m => m.default || m)
  },
  {
    name: creationsW7Czw5OYYPMeta?.name ?? "my-creations___en",
    path: creationsW7Czw5OYYPMeta?.path ?? "creations",
    meta: creationsW7Czw5OYYPMeta || {},
    alias: creationsW7Czw5OYYPMeta?.alias || [],
    redirect: creationsW7Czw5OYYPMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/creations.vue").then(m => m.default || m)
  },
  {
    name: creditskqpXEn0UasMeta?.name ?? "my-credits___en",
    path: creditskqpXEn0UasMeta?.path ?? "credits",
    meta: creditskqpXEn0UasMeta || {},
    alias: creditskqpXEn0UasMeta?.alias || [],
    redirect: creditskqpXEn0UasMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/credits.vue").then(m => m.default || m)
  },
  {
    name: facesxYqkQdfqX9Meta?.name ?? "my-faces___en",
    path: facesxYqkQdfqX9Meta?.path ?? "faces",
    meta: facesxYqkQdfqX9Meta || {},
    alias: facesxYqkQdfqX9Meta?.alias || [],
    redirect: facesxYqkQdfqX9Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/faces.vue").then(m => m.default || m)
  },
  {
    name: uploadscZSp4yZfr0Meta?.name ?? "my-uploads___en",
    path: uploadscZSp4yZfr0Meta?.path ?? "uploads",
    meta: uploadscZSp4yZfr0Meta || {},
    alias: uploadscZSp4yZfr0Meta?.alias || [],
    redirect: uploadscZSp4yZfr0Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/uploads.vue").then(m => m.default || m)
  }
],
    meta: my0dargHxM6iMeta || {},
    alias: my0dargHxM6iMeta?.alias || [],
    redirect: my0dargHxM6iMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my.vue").then(m => m.default || m)
  },
  {
    name: my0dargHxM6iMeta?.name ?? "my___ja",
    path: my0dargHxM6iMeta?.path ?? "/ja/my",
    children: [
  {
    name: accountzGIuhQIyqWMeta?.name ?? "my-account___ja",
    path: accountzGIuhQIyqWMeta?.path ?? "account",
    meta: accountzGIuhQIyqWMeta || {},
    alias: accountzGIuhQIyqWMeta?.alias || [],
    redirect: accountzGIuhQIyqWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/account.vue").then(m => m.default || m)
  },
  {
    name: creationsW7Czw5OYYPMeta?.name ?? "my-creations___ja",
    path: creationsW7Czw5OYYPMeta?.path ?? "creations",
    meta: creationsW7Czw5OYYPMeta || {},
    alias: creationsW7Czw5OYYPMeta?.alias || [],
    redirect: creationsW7Czw5OYYPMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/creations.vue").then(m => m.default || m)
  },
  {
    name: creditskqpXEn0UasMeta?.name ?? "my-credits___ja",
    path: creditskqpXEn0UasMeta?.path ?? "credits",
    meta: creditskqpXEn0UasMeta || {},
    alias: creditskqpXEn0UasMeta?.alias || [],
    redirect: creditskqpXEn0UasMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/credits.vue").then(m => m.default || m)
  },
  {
    name: facesxYqkQdfqX9Meta?.name ?? "my-faces___ja",
    path: facesxYqkQdfqX9Meta?.path ?? "faces",
    meta: facesxYqkQdfqX9Meta || {},
    alias: facesxYqkQdfqX9Meta?.alias || [],
    redirect: facesxYqkQdfqX9Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/faces.vue").then(m => m.default || m)
  },
  {
    name: uploadscZSp4yZfr0Meta?.name ?? "my-uploads___ja",
    path: uploadscZSp4yZfr0Meta?.path ?? "uploads",
    meta: uploadscZSp4yZfr0Meta || {},
    alias: uploadscZSp4yZfr0Meta?.alias || [],
    redirect: uploadscZSp4yZfr0Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/uploads.vue").then(m => m.default || m)
  }
],
    meta: my0dargHxM6iMeta || {},
    alias: my0dargHxM6iMeta?.alias || [],
    redirect: my0dargHxM6iMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my.vue").then(m => m.default || m)
  },
  {
    name: my0dargHxM6iMeta?.name ?? "my___de",
    path: my0dargHxM6iMeta?.path ?? "/de/my",
    children: [
  {
    name: accountzGIuhQIyqWMeta?.name ?? "my-account___de",
    path: accountzGIuhQIyqWMeta?.path ?? "account",
    meta: accountzGIuhQIyqWMeta || {},
    alias: accountzGIuhQIyqWMeta?.alias || [],
    redirect: accountzGIuhQIyqWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/account.vue").then(m => m.default || m)
  },
  {
    name: creationsW7Czw5OYYPMeta?.name ?? "my-creations___de",
    path: creationsW7Czw5OYYPMeta?.path ?? "creations",
    meta: creationsW7Czw5OYYPMeta || {},
    alias: creationsW7Czw5OYYPMeta?.alias || [],
    redirect: creationsW7Czw5OYYPMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/creations.vue").then(m => m.default || m)
  },
  {
    name: creditskqpXEn0UasMeta?.name ?? "my-credits___de",
    path: creditskqpXEn0UasMeta?.path ?? "credits",
    meta: creditskqpXEn0UasMeta || {},
    alias: creditskqpXEn0UasMeta?.alias || [],
    redirect: creditskqpXEn0UasMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/credits.vue").then(m => m.default || m)
  },
  {
    name: facesxYqkQdfqX9Meta?.name ?? "my-faces___de",
    path: facesxYqkQdfqX9Meta?.path ?? "faces",
    meta: facesxYqkQdfqX9Meta || {},
    alias: facesxYqkQdfqX9Meta?.alias || [],
    redirect: facesxYqkQdfqX9Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/faces.vue").then(m => m.default || m)
  },
  {
    name: uploadscZSp4yZfr0Meta?.name ?? "my-uploads___de",
    path: uploadscZSp4yZfr0Meta?.path ?? "uploads",
    meta: uploadscZSp4yZfr0Meta || {},
    alias: uploadscZSp4yZfr0Meta?.alias || [],
    redirect: uploadscZSp4yZfr0Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/uploads.vue").then(m => m.default || m)
  }
],
    meta: my0dargHxM6iMeta || {},
    alias: my0dargHxM6iMeta?.alias || [],
    redirect: my0dargHxM6iMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my.vue").then(m => m.default || m)
  },
  {
    name: my0dargHxM6iMeta?.name ?? "my___it",
    path: my0dargHxM6iMeta?.path ?? "/it/my",
    children: [
  {
    name: accountzGIuhQIyqWMeta?.name ?? "my-account___it",
    path: accountzGIuhQIyqWMeta?.path ?? "account",
    meta: accountzGIuhQIyqWMeta || {},
    alias: accountzGIuhQIyqWMeta?.alias || [],
    redirect: accountzGIuhQIyqWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/account.vue").then(m => m.default || m)
  },
  {
    name: creationsW7Czw5OYYPMeta?.name ?? "my-creations___it",
    path: creationsW7Czw5OYYPMeta?.path ?? "creations",
    meta: creationsW7Czw5OYYPMeta || {},
    alias: creationsW7Czw5OYYPMeta?.alias || [],
    redirect: creationsW7Czw5OYYPMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/creations.vue").then(m => m.default || m)
  },
  {
    name: creditskqpXEn0UasMeta?.name ?? "my-credits___it",
    path: creditskqpXEn0UasMeta?.path ?? "credits",
    meta: creditskqpXEn0UasMeta || {},
    alias: creditskqpXEn0UasMeta?.alias || [],
    redirect: creditskqpXEn0UasMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/credits.vue").then(m => m.default || m)
  },
  {
    name: facesxYqkQdfqX9Meta?.name ?? "my-faces___it",
    path: facesxYqkQdfqX9Meta?.path ?? "faces",
    meta: facesxYqkQdfqX9Meta || {},
    alias: facesxYqkQdfqX9Meta?.alias || [],
    redirect: facesxYqkQdfqX9Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/faces.vue").then(m => m.default || m)
  },
  {
    name: uploadscZSp4yZfr0Meta?.name ?? "my-uploads___it",
    path: uploadscZSp4yZfr0Meta?.path ?? "uploads",
    meta: uploadscZSp4yZfr0Meta || {},
    alias: uploadscZSp4yZfr0Meta?.alias || [],
    redirect: uploadscZSp4yZfr0Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/uploads.vue").then(m => m.default || m)
  }
],
    meta: my0dargHxM6iMeta || {},
    alias: my0dargHxM6iMeta?.alias || [],
    redirect: my0dargHxM6iMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my.vue").then(m => m.default || m)
  },
  {
    name: my0dargHxM6iMeta?.name ?? "my___fr",
    path: my0dargHxM6iMeta?.path ?? "/fr/my",
    children: [
  {
    name: accountzGIuhQIyqWMeta?.name ?? "my-account___fr",
    path: accountzGIuhQIyqWMeta?.path ?? "account",
    meta: accountzGIuhQIyqWMeta || {},
    alias: accountzGIuhQIyqWMeta?.alias || [],
    redirect: accountzGIuhQIyqWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/account.vue").then(m => m.default || m)
  },
  {
    name: creationsW7Czw5OYYPMeta?.name ?? "my-creations___fr",
    path: creationsW7Czw5OYYPMeta?.path ?? "creations",
    meta: creationsW7Czw5OYYPMeta || {},
    alias: creationsW7Czw5OYYPMeta?.alias || [],
    redirect: creationsW7Czw5OYYPMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/creations.vue").then(m => m.default || m)
  },
  {
    name: creditskqpXEn0UasMeta?.name ?? "my-credits___fr",
    path: creditskqpXEn0UasMeta?.path ?? "credits",
    meta: creditskqpXEn0UasMeta || {},
    alias: creditskqpXEn0UasMeta?.alias || [],
    redirect: creditskqpXEn0UasMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/credits.vue").then(m => m.default || m)
  },
  {
    name: facesxYqkQdfqX9Meta?.name ?? "my-faces___fr",
    path: facesxYqkQdfqX9Meta?.path ?? "faces",
    meta: facesxYqkQdfqX9Meta || {},
    alias: facesxYqkQdfqX9Meta?.alias || [],
    redirect: facesxYqkQdfqX9Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/faces.vue").then(m => m.default || m)
  },
  {
    name: uploadscZSp4yZfr0Meta?.name ?? "my-uploads___fr",
    path: uploadscZSp4yZfr0Meta?.path ?? "uploads",
    meta: uploadscZSp4yZfr0Meta || {},
    alias: uploadscZSp4yZfr0Meta?.alias || [],
    redirect: uploadscZSp4yZfr0Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/uploads.vue").then(m => m.default || m)
  }
],
    meta: my0dargHxM6iMeta || {},
    alias: my0dargHxM6iMeta?.alias || [],
    redirect: my0dargHxM6iMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my.vue").then(m => m.default || m)
  },
  {
    name: my0dargHxM6iMeta?.name ?? "my___nl",
    path: my0dargHxM6iMeta?.path ?? "/nl/my",
    children: [
  {
    name: accountzGIuhQIyqWMeta?.name ?? "my-account___nl",
    path: accountzGIuhQIyqWMeta?.path ?? "account",
    meta: accountzGIuhQIyqWMeta || {},
    alias: accountzGIuhQIyqWMeta?.alias || [],
    redirect: accountzGIuhQIyqWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/account.vue").then(m => m.default || m)
  },
  {
    name: creationsW7Czw5OYYPMeta?.name ?? "my-creations___nl",
    path: creationsW7Czw5OYYPMeta?.path ?? "creations",
    meta: creationsW7Czw5OYYPMeta || {},
    alias: creationsW7Czw5OYYPMeta?.alias || [],
    redirect: creationsW7Czw5OYYPMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/creations.vue").then(m => m.default || m)
  },
  {
    name: creditskqpXEn0UasMeta?.name ?? "my-credits___nl",
    path: creditskqpXEn0UasMeta?.path ?? "credits",
    meta: creditskqpXEn0UasMeta || {},
    alias: creditskqpXEn0UasMeta?.alias || [],
    redirect: creditskqpXEn0UasMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/credits.vue").then(m => m.default || m)
  },
  {
    name: facesxYqkQdfqX9Meta?.name ?? "my-faces___nl",
    path: facesxYqkQdfqX9Meta?.path ?? "faces",
    meta: facesxYqkQdfqX9Meta || {},
    alias: facesxYqkQdfqX9Meta?.alias || [],
    redirect: facesxYqkQdfqX9Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/faces.vue").then(m => m.default || m)
  },
  {
    name: uploadscZSp4yZfr0Meta?.name ?? "my-uploads___nl",
    path: uploadscZSp4yZfr0Meta?.path ?? "uploads",
    meta: uploadscZSp4yZfr0Meta || {},
    alias: uploadscZSp4yZfr0Meta?.alias || [],
    redirect: uploadscZSp4yZfr0Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/uploads.vue").then(m => m.default || m)
  }
],
    meta: my0dargHxM6iMeta || {},
    alias: my0dargHxM6iMeta?.alias || [],
    redirect: my0dargHxM6iMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my.vue").then(m => m.default || m)
  },
  {
    name: my0dargHxM6iMeta?.name ?? "my___pt",
    path: my0dargHxM6iMeta?.path ?? "/pt/my",
    children: [
  {
    name: accountzGIuhQIyqWMeta?.name ?? "my-account___pt",
    path: accountzGIuhQIyqWMeta?.path ?? "account",
    meta: accountzGIuhQIyqWMeta || {},
    alias: accountzGIuhQIyqWMeta?.alias || [],
    redirect: accountzGIuhQIyqWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/account.vue").then(m => m.default || m)
  },
  {
    name: creationsW7Czw5OYYPMeta?.name ?? "my-creations___pt",
    path: creationsW7Czw5OYYPMeta?.path ?? "creations",
    meta: creationsW7Czw5OYYPMeta || {},
    alias: creationsW7Czw5OYYPMeta?.alias || [],
    redirect: creationsW7Czw5OYYPMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/creations.vue").then(m => m.default || m)
  },
  {
    name: creditskqpXEn0UasMeta?.name ?? "my-credits___pt",
    path: creditskqpXEn0UasMeta?.path ?? "credits",
    meta: creditskqpXEn0UasMeta || {},
    alias: creditskqpXEn0UasMeta?.alias || [],
    redirect: creditskqpXEn0UasMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/credits.vue").then(m => m.default || m)
  },
  {
    name: facesxYqkQdfqX9Meta?.name ?? "my-faces___pt",
    path: facesxYqkQdfqX9Meta?.path ?? "faces",
    meta: facesxYqkQdfqX9Meta || {},
    alias: facesxYqkQdfqX9Meta?.alias || [],
    redirect: facesxYqkQdfqX9Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/faces.vue").then(m => m.default || m)
  },
  {
    name: uploadscZSp4yZfr0Meta?.name ?? "my-uploads___pt",
    path: uploadscZSp4yZfr0Meta?.path ?? "uploads",
    meta: uploadscZSp4yZfr0Meta || {},
    alias: uploadscZSp4yZfr0Meta?.alias || [],
    redirect: uploadscZSp4yZfr0Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my/uploads.vue").then(m => m.default || m)
  }
],
    meta: my0dargHxM6iMeta || {},
    alias: my0dargHxM6iMeta?.alias || [],
    redirect: my0dargHxM6iMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/my.vue").then(m => m.default || m)
  },
  {
    name: password_45changeqT7uDbh29HMeta?.name ?? "password-change___en",
    path: password_45changeqT7uDbh29HMeta?.path ?? "/password-change",
    meta: password_45changeqT7uDbh29HMeta || {},
    alias: password_45changeqT7uDbh29HMeta?.alias || [],
    redirect: password_45changeqT7uDbh29HMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-change.vue").then(m => m.default || m)
  },
  {
    name: password_45changeqT7uDbh29HMeta?.name ?? "password-change___ja",
    path: password_45changeqT7uDbh29HMeta?.path ?? "/ja/password-change",
    meta: password_45changeqT7uDbh29HMeta || {},
    alias: password_45changeqT7uDbh29HMeta?.alias || [],
    redirect: password_45changeqT7uDbh29HMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-change.vue").then(m => m.default || m)
  },
  {
    name: password_45changeqT7uDbh29HMeta?.name ?? "password-change___de",
    path: password_45changeqT7uDbh29HMeta?.path ?? "/de/password-change",
    meta: password_45changeqT7uDbh29HMeta || {},
    alias: password_45changeqT7uDbh29HMeta?.alias || [],
    redirect: password_45changeqT7uDbh29HMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-change.vue").then(m => m.default || m)
  },
  {
    name: password_45changeqT7uDbh29HMeta?.name ?? "password-change___it",
    path: password_45changeqT7uDbh29HMeta?.path ?? "/it/password-change",
    meta: password_45changeqT7uDbh29HMeta || {},
    alias: password_45changeqT7uDbh29HMeta?.alias || [],
    redirect: password_45changeqT7uDbh29HMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-change.vue").then(m => m.default || m)
  },
  {
    name: password_45changeqT7uDbh29HMeta?.name ?? "password-change___fr",
    path: password_45changeqT7uDbh29HMeta?.path ?? "/fr/password-change",
    meta: password_45changeqT7uDbh29HMeta || {},
    alias: password_45changeqT7uDbh29HMeta?.alias || [],
    redirect: password_45changeqT7uDbh29HMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-change.vue").then(m => m.default || m)
  },
  {
    name: password_45changeqT7uDbh29HMeta?.name ?? "password-change___nl",
    path: password_45changeqT7uDbh29HMeta?.path ?? "/nl/password-change",
    meta: password_45changeqT7uDbh29HMeta || {},
    alias: password_45changeqT7uDbh29HMeta?.alias || [],
    redirect: password_45changeqT7uDbh29HMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-change.vue").then(m => m.default || m)
  },
  {
    name: password_45changeqT7uDbh29HMeta?.name ?? "password-change___pt",
    path: password_45changeqT7uDbh29HMeta?.path ?? "/pt/password-change",
    meta: password_45changeqT7uDbh29HMeta || {},
    alias: password_45changeqT7uDbh29HMeta?.alias || [],
    redirect: password_45changeqT7uDbh29HMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-change.vue").then(m => m.default || m)
  },
  {
    name: password_45reset6pLgh9teUjMeta?.name ?? "password-reset___en",
    path: password_45reset6pLgh9teUjMeta?.path ?? "/password-reset",
    meta: password_45reset6pLgh9teUjMeta || {},
    alias: password_45reset6pLgh9teUjMeta?.alias || [],
    redirect: password_45reset6pLgh9teUjMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45reset6pLgh9teUjMeta?.name ?? "password-reset___ja",
    path: password_45reset6pLgh9teUjMeta?.path ?? "/ja/password-reset",
    meta: password_45reset6pLgh9teUjMeta || {},
    alias: password_45reset6pLgh9teUjMeta?.alias || [],
    redirect: password_45reset6pLgh9teUjMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45reset6pLgh9teUjMeta?.name ?? "password-reset___de",
    path: password_45reset6pLgh9teUjMeta?.path ?? "/de/password-reset",
    meta: password_45reset6pLgh9teUjMeta || {},
    alias: password_45reset6pLgh9teUjMeta?.alias || [],
    redirect: password_45reset6pLgh9teUjMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45reset6pLgh9teUjMeta?.name ?? "password-reset___it",
    path: password_45reset6pLgh9teUjMeta?.path ?? "/it/password-reset",
    meta: password_45reset6pLgh9teUjMeta || {},
    alias: password_45reset6pLgh9teUjMeta?.alias || [],
    redirect: password_45reset6pLgh9teUjMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45reset6pLgh9teUjMeta?.name ?? "password-reset___fr",
    path: password_45reset6pLgh9teUjMeta?.path ?? "/fr/password-reset",
    meta: password_45reset6pLgh9teUjMeta || {},
    alias: password_45reset6pLgh9teUjMeta?.alias || [],
    redirect: password_45reset6pLgh9teUjMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45reset6pLgh9teUjMeta?.name ?? "password-reset___nl",
    path: password_45reset6pLgh9teUjMeta?.path ?? "/nl/password-reset",
    meta: password_45reset6pLgh9teUjMeta || {},
    alias: password_45reset6pLgh9teUjMeta?.alias || [],
    redirect: password_45reset6pLgh9teUjMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45reset6pLgh9teUjMeta?.name ?? "password-reset___pt",
    path: password_45reset6pLgh9teUjMeta?.path ?? "/pt/password-reset",
    meta: password_45reset6pLgh9teUjMeta || {},
    alias: password_45reset6pLgh9teUjMeta?.alias || [],
    redirect: password_45reset6pLgh9teUjMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/password-reset.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedisTKdFKLwvMeta?.name ?? "payment-failed___en",
    path: payment_45failedisTKdFKLwvMeta?.path ?? "/payment-failed",
    meta: payment_45failedisTKdFKLwvMeta || {},
    alias: payment_45failedisTKdFKLwvMeta?.alias || [],
    redirect: payment_45failedisTKdFKLwvMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedisTKdFKLwvMeta?.name ?? "payment-failed___ja",
    path: payment_45failedisTKdFKLwvMeta?.path ?? "/ja/payment-failed",
    meta: payment_45failedisTKdFKLwvMeta || {},
    alias: payment_45failedisTKdFKLwvMeta?.alias || [],
    redirect: payment_45failedisTKdFKLwvMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedisTKdFKLwvMeta?.name ?? "payment-failed___de",
    path: payment_45failedisTKdFKLwvMeta?.path ?? "/de/payment-failed",
    meta: payment_45failedisTKdFKLwvMeta || {},
    alias: payment_45failedisTKdFKLwvMeta?.alias || [],
    redirect: payment_45failedisTKdFKLwvMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedisTKdFKLwvMeta?.name ?? "payment-failed___it",
    path: payment_45failedisTKdFKLwvMeta?.path ?? "/it/payment-failed",
    meta: payment_45failedisTKdFKLwvMeta || {},
    alias: payment_45failedisTKdFKLwvMeta?.alias || [],
    redirect: payment_45failedisTKdFKLwvMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedisTKdFKLwvMeta?.name ?? "payment-failed___fr",
    path: payment_45failedisTKdFKLwvMeta?.path ?? "/fr/payment-failed",
    meta: payment_45failedisTKdFKLwvMeta || {},
    alias: payment_45failedisTKdFKLwvMeta?.alias || [],
    redirect: payment_45failedisTKdFKLwvMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedisTKdFKLwvMeta?.name ?? "payment-failed___nl",
    path: payment_45failedisTKdFKLwvMeta?.path ?? "/nl/payment-failed",
    meta: payment_45failedisTKdFKLwvMeta || {},
    alias: payment_45failedisTKdFKLwvMeta?.alias || [],
    redirect: payment_45failedisTKdFKLwvMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedisTKdFKLwvMeta?.name ?? "payment-failed___pt",
    path: payment_45failedisTKdFKLwvMeta?.path ?? "/pt/payment-failed",
    meta: payment_45failedisTKdFKLwvMeta || {},
    alias: payment_45failedisTKdFKLwvMeta?.alias || [],
    redirect: payment_45failedisTKdFKLwvMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45successAGfXBekK7fMeta?.name ?? "payment-success___en",
    path: payment_45successAGfXBekK7fMeta?.path ?? "/payment-success",
    meta: payment_45successAGfXBekK7fMeta || {},
    alias: payment_45successAGfXBekK7fMeta?.alias || [],
    redirect: payment_45successAGfXBekK7fMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successAGfXBekK7fMeta?.name ?? "payment-success___ja",
    path: payment_45successAGfXBekK7fMeta?.path ?? "/ja/payment-success",
    meta: payment_45successAGfXBekK7fMeta || {},
    alias: payment_45successAGfXBekK7fMeta?.alias || [],
    redirect: payment_45successAGfXBekK7fMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successAGfXBekK7fMeta?.name ?? "payment-success___de",
    path: payment_45successAGfXBekK7fMeta?.path ?? "/de/payment-success",
    meta: payment_45successAGfXBekK7fMeta || {},
    alias: payment_45successAGfXBekK7fMeta?.alias || [],
    redirect: payment_45successAGfXBekK7fMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successAGfXBekK7fMeta?.name ?? "payment-success___it",
    path: payment_45successAGfXBekK7fMeta?.path ?? "/it/payment-success",
    meta: payment_45successAGfXBekK7fMeta || {},
    alias: payment_45successAGfXBekK7fMeta?.alias || [],
    redirect: payment_45successAGfXBekK7fMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successAGfXBekK7fMeta?.name ?? "payment-success___fr",
    path: payment_45successAGfXBekK7fMeta?.path ?? "/fr/payment-success",
    meta: payment_45successAGfXBekK7fMeta || {},
    alias: payment_45successAGfXBekK7fMeta?.alias || [],
    redirect: payment_45successAGfXBekK7fMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successAGfXBekK7fMeta?.name ?? "payment-success___nl",
    path: payment_45successAGfXBekK7fMeta?.path ?? "/nl/payment-success",
    meta: payment_45successAGfXBekK7fMeta || {},
    alias: payment_45successAGfXBekK7fMeta?.alias || [],
    redirect: payment_45successAGfXBekK7fMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successAGfXBekK7fMeta?.name ?? "payment-success___pt",
    path: payment_45successAGfXBekK7fMeta?.path ?? "/pt/payment-success",
    meta: payment_45successAGfXBekK7fMeta || {},
    alias: payment_45successAGfXBekK7fMeta?.alias || [],
    redirect: payment_45successAGfXBekK7fMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: policyNKohT57BqpMeta?.name ?? "policy___en",
    path: policyNKohT57BqpMeta?.path ?? "/policy",
    meta: policyNKohT57BqpMeta || {},
    alias: policyNKohT57BqpMeta?.alias || [],
    redirect: policyNKohT57BqpMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/policy.vue").then(m => m.default || m)
  },
  {
    name: policyNKohT57BqpMeta?.name ?? "policy___ja",
    path: policyNKohT57BqpMeta?.path ?? "/ja/policy",
    meta: policyNKohT57BqpMeta || {},
    alias: policyNKohT57BqpMeta?.alias || [],
    redirect: policyNKohT57BqpMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/policy.vue").then(m => m.default || m)
  },
  {
    name: policyNKohT57BqpMeta?.name ?? "policy___de",
    path: policyNKohT57BqpMeta?.path ?? "/de/policy",
    meta: policyNKohT57BqpMeta || {},
    alias: policyNKohT57BqpMeta?.alias || [],
    redirect: policyNKohT57BqpMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/policy.vue").then(m => m.default || m)
  },
  {
    name: policyNKohT57BqpMeta?.name ?? "policy___it",
    path: policyNKohT57BqpMeta?.path ?? "/it/policy",
    meta: policyNKohT57BqpMeta || {},
    alias: policyNKohT57BqpMeta?.alias || [],
    redirect: policyNKohT57BqpMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/policy.vue").then(m => m.default || m)
  },
  {
    name: policyNKohT57BqpMeta?.name ?? "policy___fr",
    path: policyNKohT57BqpMeta?.path ?? "/fr/policy",
    meta: policyNKohT57BqpMeta || {},
    alias: policyNKohT57BqpMeta?.alias || [],
    redirect: policyNKohT57BqpMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/policy.vue").then(m => m.default || m)
  },
  {
    name: policyNKohT57BqpMeta?.name ?? "policy___nl",
    path: policyNKohT57BqpMeta?.path ?? "/nl/policy",
    meta: policyNKohT57BqpMeta || {},
    alias: policyNKohT57BqpMeta?.alias || [],
    redirect: policyNKohT57BqpMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/policy.vue").then(m => m.default || m)
  },
  {
    name: policyNKohT57BqpMeta?.name ?? "policy___pt",
    path: policyNKohT57BqpMeta?.path ?? "/pt/policy",
    meta: policyNKohT57BqpMeta || {},
    alias: policyNKohT57BqpMeta?.alias || [],
    redirect: policyNKohT57BqpMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/policy.vue").then(m => m.default || m)
  },
  {
    name: pricingIYNdvfoSO6Meta?.name ?? "pricing___en",
    path: pricingIYNdvfoSO6Meta?.path ?? "/pricing",
    meta: pricingIYNdvfoSO6Meta || {},
    alias: pricingIYNdvfoSO6Meta?.alias || [],
    redirect: pricingIYNdvfoSO6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingIYNdvfoSO6Meta?.name ?? "pricing___ja",
    path: pricingIYNdvfoSO6Meta?.path ?? "/ja/pricing",
    meta: pricingIYNdvfoSO6Meta || {},
    alias: pricingIYNdvfoSO6Meta?.alias || [],
    redirect: pricingIYNdvfoSO6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingIYNdvfoSO6Meta?.name ?? "pricing___de",
    path: pricingIYNdvfoSO6Meta?.path ?? "/de/pricing",
    meta: pricingIYNdvfoSO6Meta || {},
    alias: pricingIYNdvfoSO6Meta?.alias || [],
    redirect: pricingIYNdvfoSO6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingIYNdvfoSO6Meta?.name ?? "pricing___it",
    path: pricingIYNdvfoSO6Meta?.path ?? "/it/pricing",
    meta: pricingIYNdvfoSO6Meta || {},
    alias: pricingIYNdvfoSO6Meta?.alias || [],
    redirect: pricingIYNdvfoSO6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingIYNdvfoSO6Meta?.name ?? "pricing___fr",
    path: pricingIYNdvfoSO6Meta?.path ?? "/fr/pricing",
    meta: pricingIYNdvfoSO6Meta || {},
    alias: pricingIYNdvfoSO6Meta?.alias || [],
    redirect: pricingIYNdvfoSO6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingIYNdvfoSO6Meta?.name ?? "pricing___nl",
    path: pricingIYNdvfoSO6Meta?.path ?? "/nl/pricing",
    meta: pricingIYNdvfoSO6Meta || {},
    alias: pricingIYNdvfoSO6Meta?.alias || [],
    redirect: pricingIYNdvfoSO6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: pricingIYNdvfoSO6Meta?.name ?? "pricing___pt",
    path: pricingIYNdvfoSO6Meta?.path ?? "/pt/pricing",
    meta: pricingIYNdvfoSO6Meta || {},
    alias: pricingIYNdvfoSO6Meta?.alias || [],
    redirect: pricingIYNdvfoSO6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: redeemn604VeRd4vMeta?.name ?? "redeem___en",
    path: redeemn604VeRd4vMeta?.path ?? "/redeem",
    meta: redeemn604VeRd4vMeta || {},
    alias: redeemn604VeRd4vMeta?.alias || [],
    redirect: redeemn604VeRd4vMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/redeem.vue").then(m => m.default || m)
  },
  {
    name: redeemn604VeRd4vMeta?.name ?? "redeem___ja",
    path: redeemn604VeRd4vMeta?.path ?? "/ja/redeem",
    meta: redeemn604VeRd4vMeta || {},
    alias: redeemn604VeRd4vMeta?.alias || [],
    redirect: redeemn604VeRd4vMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/redeem.vue").then(m => m.default || m)
  },
  {
    name: redeemn604VeRd4vMeta?.name ?? "redeem___de",
    path: redeemn604VeRd4vMeta?.path ?? "/de/redeem",
    meta: redeemn604VeRd4vMeta || {},
    alias: redeemn604VeRd4vMeta?.alias || [],
    redirect: redeemn604VeRd4vMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/redeem.vue").then(m => m.default || m)
  },
  {
    name: redeemn604VeRd4vMeta?.name ?? "redeem___it",
    path: redeemn604VeRd4vMeta?.path ?? "/it/redeem",
    meta: redeemn604VeRd4vMeta || {},
    alias: redeemn604VeRd4vMeta?.alias || [],
    redirect: redeemn604VeRd4vMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/redeem.vue").then(m => m.default || m)
  },
  {
    name: redeemn604VeRd4vMeta?.name ?? "redeem___fr",
    path: redeemn604VeRd4vMeta?.path ?? "/fr/redeem",
    meta: redeemn604VeRd4vMeta || {},
    alias: redeemn604VeRd4vMeta?.alias || [],
    redirect: redeemn604VeRd4vMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/redeem.vue").then(m => m.default || m)
  },
  {
    name: redeemn604VeRd4vMeta?.name ?? "redeem___nl",
    path: redeemn604VeRd4vMeta?.path ?? "/nl/redeem",
    meta: redeemn604VeRd4vMeta || {},
    alias: redeemn604VeRd4vMeta?.alias || [],
    redirect: redeemn604VeRd4vMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/redeem.vue").then(m => m.default || m)
  },
  {
    name: redeemn604VeRd4vMeta?.name ?? "redeem___pt",
    path: redeemn604VeRd4vMeta?.path ?? "/pt/redeem",
    meta: redeemn604VeRd4vMeta || {},
    alias: redeemn604VeRd4vMeta?.alias || [],
    redirect: redeemn604VeRd4vMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/redeem.vue").then(m => m.default || m)
  },
  {
    name: signupY93ILdpGpbMeta?.name ?? "signup___en",
    path: signupY93ILdpGpbMeta?.path ?? "/signup",
    meta: signupY93ILdpGpbMeta || {},
    alias: signupY93ILdpGpbMeta?.alias || [],
    redirect: signupY93ILdpGpbMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/signup.vue").then(m => m.default || m)
  },
  {
    name: signupY93ILdpGpbMeta?.name ?? "signup___ja",
    path: signupY93ILdpGpbMeta?.path ?? "/ja/signup",
    meta: signupY93ILdpGpbMeta || {},
    alias: signupY93ILdpGpbMeta?.alias || [],
    redirect: signupY93ILdpGpbMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/signup.vue").then(m => m.default || m)
  },
  {
    name: signupY93ILdpGpbMeta?.name ?? "signup___de",
    path: signupY93ILdpGpbMeta?.path ?? "/de/signup",
    meta: signupY93ILdpGpbMeta || {},
    alias: signupY93ILdpGpbMeta?.alias || [],
    redirect: signupY93ILdpGpbMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/signup.vue").then(m => m.default || m)
  },
  {
    name: signupY93ILdpGpbMeta?.name ?? "signup___it",
    path: signupY93ILdpGpbMeta?.path ?? "/it/signup",
    meta: signupY93ILdpGpbMeta || {},
    alias: signupY93ILdpGpbMeta?.alias || [],
    redirect: signupY93ILdpGpbMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/signup.vue").then(m => m.default || m)
  },
  {
    name: signupY93ILdpGpbMeta?.name ?? "signup___fr",
    path: signupY93ILdpGpbMeta?.path ?? "/fr/signup",
    meta: signupY93ILdpGpbMeta || {},
    alias: signupY93ILdpGpbMeta?.alias || [],
    redirect: signupY93ILdpGpbMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/signup.vue").then(m => m.default || m)
  },
  {
    name: signupY93ILdpGpbMeta?.name ?? "signup___nl",
    path: signupY93ILdpGpbMeta?.path ?? "/nl/signup",
    meta: signupY93ILdpGpbMeta || {},
    alias: signupY93ILdpGpbMeta?.alias || [],
    redirect: signupY93ILdpGpbMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/signup.vue").then(m => m.default || m)
  },
  {
    name: signupY93ILdpGpbMeta?.name ?? "signup___pt",
    path: signupY93ILdpGpbMeta?.path ?? "/pt/signup",
    meta: signupY93ILdpGpbMeta || {},
    alias: signupY93ILdpGpbMeta?.alias || [],
    redirect: signupY93ILdpGpbMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/signup.vue").then(m => m.default || m)
  },
  {
    name: termsq5qlZHSSonMeta?.name ?? "terms___en",
    path: termsq5qlZHSSonMeta?.path ?? "/terms",
    meta: termsq5qlZHSSonMeta || {},
    alias: termsq5qlZHSSonMeta?.alias || [],
    redirect: termsq5qlZHSSonMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/terms.vue").then(m => m.default || m)
  },
  {
    name: termsq5qlZHSSonMeta?.name ?? "terms___ja",
    path: termsq5qlZHSSonMeta?.path ?? "/ja/terms",
    meta: termsq5qlZHSSonMeta || {},
    alias: termsq5qlZHSSonMeta?.alias || [],
    redirect: termsq5qlZHSSonMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/terms.vue").then(m => m.default || m)
  },
  {
    name: termsq5qlZHSSonMeta?.name ?? "terms___de",
    path: termsq5qlZHSSonMeta?.path ?? "/de/terms",
    meta: termsq5qlZHSSonMeta || {},
    alias: termsq5qlZHSSonMeta?.alias || [],
    redirect: termsq5qlZHSSonMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/terms.vue").then(m => m.default || m)
  },
  {
    name: termsq5qlZHSSonMeta?.name ?? "terms___it",
    path: termsq5qlZHSSonMeta?.path ?? "/it/terms",
    meta: termsq5qlZHSSonMeta || {},
    alias: termsq5qlZHSSonMeta?.alias || [],
    redirect: termsq5qlZHSSonMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/terms.vue").then(m => m.default || m)
  },
  {
    name: termsq5qlZHSSonMeta?.name ?? "terms___fr",
    path: termsq5qlZHSSonMeta?.path ?? "/fr/terms",
    meta: termsq5qlZHSSonMeta || {},
    alias: termsq5qlZHSSonMeta?.alias || [],
    redirect: termsq5qlZHSSonMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/terms.vue").then(m => m.default || m)
  },
  {
    name: termsq5qlZHSSonMeta?.name ?? "terms___nl",
    path: termsq5qlZHSSonMeta?.path ?? "/nl/terms",
    meta: termsq5qlZHSSonMeta || {},
    alias: termsq5qlZHSSonMeta?.alias || [],
    redirect: termsq5qlZHSSonMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/terms.vue").then(m => m.default || m)
  },
  {
    name: termsq5qlZHSSonMeta?.name ?? "terms___pt",
    path: termsq5qlZHSSonMeta?.path ?? "/pt/terms",
    meta: termsq5qlZHSSonMeta || {},
    alias: termsq5qlZHSSonMeta?.alias || [],
    redirect: termsq5qlZHSSonMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/terms.vue").then(m => m.default || m)
  },
  {
    name: g2a_45instructionJWnLXVDs0aMeta?.name ?? "tutorial-g2a-instruction___en",
    path: g2a_45instructionJWnLXVDs0aMeta?.path ?? "/tutorial/g2a-instruction",
    meta: g2a_45instructionJWnLXVDs0aMeta || {},
    alias: g2a_45instructionJWnLXVDs0aMeta?.alias || [],
    redirect: g2a_45instructionJWnLXVDs0aMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/tutorial/g2a-instruction.vue").then(m => m.default || m)
  },
  {
    name: g2a_45instructionJWnLXVDs0aMeta?.name ?? "tutorial-g2a-instruction___ja",
    path: g2a_45instructionJWnLXVDs0aMeta?.path ?? "/ja/tutorial/g2a-instruction",
    meta: g2a_45instructionJWnLXVDs0aMeta || {},
    alias: g2a_45instructionJWnLXVDs0aMeta?.alias || [],
    redirect: g2a_45instructionJWnLXVDs0aMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/tutorial/g2a-instruction.vue").then(m => m.default || m)
  },
  {
    name: g2a_45instructionJWnLXVDs0aMeta?.name ?? "tutorial-g2a-instruction___de",
    path: g2a_45instructionJWnLXVDs0aMeta?.path ?? "/de/tutorial/g2a-instruction",
    meta: g2a_45instructionJWnLXVDs0aMeta || {},
    alias: g2a_45instructionJWnLXVDs0aMeta?.alias || [],
    redirect: g2a_45instructionJWnLXVDs0aMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/tutorial/g2a-instruction.vue").then(m => m.default || m)
  },
  {
    name: g2a_45instructionJWnLXVDs0aMeta?.name ?? "tutorial-g2a-instruction___it",
    path: g2a_45instructionJWnLXVDs0aMeta?.path ?? "/it/tutorial/g2a-instruction",
    meta: g2a_45instructionJWnLXVDs0aMeta || {},
    alias: g2a_45instructionJWnLXVDs0aMeta?.alias || [],
    redirect: g2a_45instructionJWnLXVDs0aMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/tutorial/g2a-instruction.vue").then(m => m.default || m)
  },
  {
    name: g2a_45instructionJWnLXVDs0aMeta?.name ?? "tutorial-g2a-instruction___fr",
    path: g2a_45instructionJWnLXVDs0aMeta?.path ?? "/fr/tutorial/g2a-instruction",
    meta: g2a_45instructionJWnLXVDs0aMeta || {},
    alias: g2a_45instructionJWnLXVDs0aMeta?.alias || [],
    redirect: g2a_45instructionJWnLXVDs0aMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/tutorial/g2a-instruction.vue").then(m => m.default || m)
  },
  {
    name: g2a_45instructionJWnLXVDs0aMeta?.name ?? "tutorial-g2a-instruction___nl",
    path: g2a_45instructionJWnLXVDs0aMeta?.path ?? "/nl/tutorial/g2a-instruction",
    meta: g2a_45instructionJWnLXVDs0aMeta || {},
    alias: g2a_45instructionJWnLXVDs0aMeta?.alias || [],
    redirect: g2a_45instructionJWnLXVDs0aMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/tutorial/g2a-instruction.vue").then(m => m.default || m)
  },
  {
    name: g2a_45instructionJWnLXVDs0aMeta?.name ?? "tutorial-g2a-instruction___pt",
    path: g2a_45instructionJWnLXVDs0aMeta?.path ?? "/pt/tutorial/g2a-instruction",
    meta: g2a_45instructionJWnLXVDs0aMeta || {},
    alias: g2a_45instructionJWnLXVDs0aMeta?.alias || [],
    redirect: g2a_45instructionJWnLXVDs0aMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/tutorial/g2a-instruction.vue").then(m => m.default || m)
  }
]